import { useAppSelector } from '../../app/hooks'

const useDefaultLayout = () => {
  const {
    data,
    loading: loadingDetectedZones,
    error,
  } = useAppSelector((state) => state.detectedZones)

  return {
    loading: loadingDetectedZones,
  }
}

export default useDefaultLayout
